<script setup>
  import ListeLoties from '@/components/ListeLoties.vue'
  import ListeActions from '@/components/ListeActions.vue'
  import ListeCommentaires from '@/components/ListeCommentaires.vue'
  import InfosArticles from '@/components/InfosArticle.vue'
  import AjoutCommentaires from '@/components/AjoutCommentaires.vue'
  import ListeEspaces from '@/components/ListeEspaces.vue'
  import LienConstructeur from '@/components/LienConstructeur.vue'
</script>

<template>
  <div class="home">
   
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <button  @click="generateRoutePrev">Article précédent</button>
        </div>
        <div class="col-lg-4">
          <button class="back" @click="goBack"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
            </svg>Retour</button>
        </div>
        <div class="col-lg-4">
          <button   @click="generateRouteNext">Article suivant</button>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div>
            <InfosArticles/>
          </div>
          <div >
            <AjoutCommentaires v-if="loggedInRole !== 'production'"/>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <ListeLoties/>
            <ListeEspaces/>
            <LienConstructeur/>
            <ListeCommentaires/>
            <ListeActions v-if="loggedInRole !== 'client' && loggedInRole !== 'be'"/>
          </div>
        
        </div>

      </div>
    </div>
    
    
    
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'


export default {
  data() {
      return {
        designation: null,
        designation2: null,
        designation3: null,
        codeArticle: null,
        magasin: null,
        currentPage: null,
        searchTerm: null,
        selectedFourn: null,
        selectedMag: null,
        showOnlyAvailable: null,
        sortColumn: null,
        sortDirection: null,
        article: [],
        prevCoarti: null,
        nextCoarti: null,
        prevDesa1: null,
        nextDesa1: null,
        prevDesa2: null,
        nextDesa2: null,
        prevDesa3: null,
        nextDesa3: null,
        prevNomMagasins: null,
        nextNomMagasins: null,

        loggedInEmail: null,
        loggedInRole: null,
        showIframe: false, // Initialisation à false pour masquer l'iframe
        activeIframeIndex: null,
        plans: [],
      };
  },
  created() {


    this.designation = this.$route.params.designation === "empty" ? "" : this.$route.params.designation;
    this.designation2 = this.$route.params.designation2 === "empty" ? "" : this.$route.params.designation2;
    this.designation3 = this.$route.params.designation3 === "empty" ? "" : this.$route.params.designation3;
    this.codeArticle = this.$route.params.codeArticle === "empty" ? "" : this.$route.params.codeArticle;
    this.magasin = this.$route.params.magasin === "empty" ? "" : this.$route.params.magasin;
    this.currentPage = this.$route.params.currentPage === "empty" ? "" : this.$route.params.currentPage;
    this.searchTerm = this.$route.params.searchTerm === "empty" ? "" : this.$route.params.searchTerm;
    this.selectedFourn = this.$route.params.selectedFourn === "empty" ? "" : this.$route.params.selectedFourn;
    this.selectedMag = this.$route.params.selectedMag === "empty" ? "" : this.$route.params.selectedMag;
    this.showOnlyAvailable = this.$route.params.showOnlyAvailable === "empty" ? "" : this.$route.params.showOnlyAvailable;
    this.sortColumn = this.$route.params.sortColumn === "empty" ? "" : this.$route.params.sortColumn;
    this.sortDirection = this.$route.params.sortDirection === "empty" ? "" : this.$route.params.sortDirection;

      
      
  },
  mounted() {
    axios.post('https://www.simef.fr/espace-client/api/getPlansArticles.php', {
      codeArticle: this.codeArticle
    })
    .then(response => {
        this.plans = response.data;
    })
    .catch(error => {
        console.log(error);
    });

    
    

  
    axios.post('https://www.simef.fr/espace-client/api/getArticles.php', {
      page: this.currentPage,
      searchTerm: this.searchTerm,
      selectedMag: this.selectedMag,
      selectedFourn: this.selectedFourn,
      loggedInEmail: this.loggedInEmail,
      showOnlyAvailable: this.showOnlyAvailable,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection,
    })
    .then(response => {
      this.articles = response.data.articles;

      console.log(this.articles);






      if (this.articles && this.articles.length > 0) {
        const index = this.articles.findIndex(article => article.coarti.trim() === this.codeArticle.trim());

        if (index !== -1) {
          this.prevCoarti = index > 0 ? this.articles[index - 1].coarti : null;
          this.nextCoarti = index < this.articles.length - 1 ? this.articles[index + 1].coarti : null;

          // Store prev and next values for desa1, desa2, desa3, and nom_magasins
          this.prevDesa1 = index > 0 ? this.articles[index - 1].desa1 : null;
          this.nextDesa1 = index < this.articles.length - 1 ? this.articles[index + 1].desa1 : null;

          this.prevDesa2 = index > 0 ? this.articles[index - 1].desa2 : null;
          this.nextDesa2 = index < this.articles.length - 1 ? this.articles[index + 1].desa2 : null;

          this.prevDesa3 = index > 0 ? this.articles[index - 1].desa3 : null;
          this.nextDesa3 = index < this.articles.length - 1 ? this.articles[index + 1].desa3 : null;

          this.prevNomMagasins = index > 0 ? this.articles[index - 1].nom_magasins : null;
          this.nextNomMagasins = index < this.articles.length - 1 ? this.articles[index + 1].nom_magasins : null;
        } else {
          this.prevCoarti = null;
          this.nextCoarti = null;

          // Set null for prev and next values for desa1, desa2, desa3, and nom_magasins
          this.prevDesa1 = null;
          this.nextDesa1 = null;

          this.prevDesa2 = null;
          this.nextDesa2 = null;

          this.prevDesa3 = null;
          this.nextDesa3 = null;

          this.prevNomMagasins = null;
          this.nextNomMagasins = null;
        }

        console.log("Previous coarti:", this.prevCoarti);
        console.log("Next coarti:", this.nextCoarti);

        console.log("Previous desa1:", this.prevDesa1);
        console.log("Next desa1:", this.nextDesa1);

        // Repeat similar logs for desa2, desa3, and nom_magasins
      } else {
        console.error("Articles data is not available.");
      }









      
    })
    .catch(error => {
      console.error(error);
      

    })
    .finally(() => {
      this.isLoading = false; // Hide loader
    });

    

  },
  methods: {
    goBack() {
      const queryParams = {
        page: this.currentPage,
        searchTerm: this.searchTerm,
        selectedMag: this.selectedMag,
        selectedFourn: this.selectedFourn,
        showOnlyAvailable: this.showOnlyAvailable
      };
      this.$router.go(-1);
      this.$router.push({ query: queryParams });
    },
    toggleIframe(index) {
      this.activeIframeIndex = index;
      this.showIframe = !this.showIframe;
    },
    generateRoutePrev() {
      // Remplacez les valeurs vides par "empty"
      var designation = this.prevDesa1.replace(/\//g, '-').trim() || 'empty';
      var designation2 = this.prevDesa2.replace(/\//g, '-').trim() || 'empty';
      var designation3 = this.prevDesa3.replace(/\//g, '-').trim() || 'empty';
      var prevCoarti = this.prevCoarti.replace(/\//g, '-').trim() || 'empty';
      var magasin = this.prevNomMagasins.replace(/\//g, '-').trim() || 'empty';
      var currentPage = this.currentPage.replace(/\//g, '-').trim() || 'empty';
      var searchTerm = this.searchTerm.replace(/\//g, '-').trim() || 'empty';
      var selectedFourn = this.selectedFourn.replace(/\//g, '-').trim() || 'empty';
      var selectedMag = this.selectedMag.replace(/\//g, '-').trim() || 'empty';
      var showOnlyAvailable = this.showOnlyAvailable.replace(/\//g, '-').trim() || 'empty';
      var sortColumn = this.sortColumn.replace(/\//g, '-').trim() || 'empty';
      var sortDirection = this.sortDirection.replace(/\//g, '-').trim() || 'empty';

      // Construit la chaîne de route
      const route = `/espace-client/article/${designation}/${designation2}/${designation3}/${prevCoarti}/${magasin}/${currentPage}/${searchTerm}/${selectedFourn}/${selectedMag}/${showOnlyAvailable}/${sortColumn}/${sortDirection}`;
      
      window.location.href = route;
      
    },

    generateRouteNext() {
      // Remplacez les valeurs vides par "empty"
      var designation = this.nextDesa1.replace(/\//g, '-').trim() || 'empty';
      var designation2 = this.nextDesa2.replace(/\//g, '-').trim() || 'empty';
      var designation3 = this.nextDesa3.replace(/\//g, '-').trim() || 'empty';
      var nextCoarti = this.nextCoarti.replace(/\//g, '-').trim() || 'empty';
      var magasin = this.nextNomMagasins.replace(/\//g, '-').trim() || 'empty';
      var currentPage = this.currentPage.replace(/\//g, '-').trim() || 'empty';
      var searchTerm = this.searchTerm.replace(/\//g, '-').trim() || 'empty';
      var selectedFourn = this.selectedFourn.replace(/\//g, '-').trim() || 'empty';
      var selectedMag = this.selectedMag.replace(/\//g, '-').trim() || 'empty';
      var showOnlyAvailable = this.showOnlyAvailable.replace(/\//g, '-').trim() || 'empty';
      var sortColumn = this.sortColumn.replace(/\//g, '-').trim() || 'empty';
      var sortDirection = this.sortDirection.replace(/\//g, '-').trim() || 'empty';

      // Construit la chaîne de route
      const route = `/espace-client/article/${designation}/${designation2}/${designation3}/${nextCoarti}/${magasin}/${currentPage}/${searchTerm}/${selectedFourn}/${selectedMag}/${showOnlyAvailable}/${sortColumn}/${sortDirection}`;
      
      window.location.href = route;
    },
  
   
  }
}
</script>

<style lang="scss">

 button.back {
  display: inherit;
  margin: auto;
  margin-bottom: 20px!important;
  display: flex;
  align-items: center;
 }

 @media screen and (max-width:992px) {
  .back {
    margin-top: 30px!important;
  }
}

 button.back svg {
  height: 24px;
  width: 24px;
  margin-right: 6px;
 }

 .iframes {
  margin-bottom: 25px;
  .iframe {
    display: flex;
    align-items: center;
    flex-direction: column;
    iframe {
      width: 100%;
      min-height: 600px;
    }
   }
 }

</style>
